import React from "react";
import { Checkbox } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { FieldSet, FormRow, FormRowFormats, Input } from "../../../../forms";
import { VALIDATION_FIELD } from "../../../../rapidform/formValidation";
import { RapidForm } from "../../../../rapidform/index";
import {
    getFormById,
    getSelectedAddress,
    isCustomAddressSelected as isCustomAddressSelectedSelector,
    isSelectedPackageCabinDIY,
} from "../../../state/selectors";
import TEXT from "../../../text-consts";
import "./PersonalDetailsForm.less";

interface StateProps {
    address?: string;
    fwaForm: Form;
    isCustomAddressSelected: boolean;
    shouldShowAddressInputs: boolean;
}

interface PersonalDetailsFormProps extends StateProps {
    onSubmitDetails: () => void;
    setCustomAddressChecked: (value: boolean) => void;
}

const PersonalDetailsForm: React.FC<PersonalDetailsFormProps> = ({
    fwaForm,
    address,
    shouldShowAddressInputs,
    isCustomAddressSelected,
    setCustomAddressChecked,
    onSubmitDetails,
}) => (
    <div className="fwa-personal-details-form">
        <RapidForm
            id={FORM_ID.PERSONAL_DETAILS_FWA}
            action={"#"}
            errors={fwaForm.errors}
            values={fwaForm.values}
            visible={fwaForm.visible}
            started={fwaForm.started}
            onSubmit={onSubmitDetails}
        >
            <FieldSet name="details">
                <div className="fwa-personal-details-form__field" data-di-mask>
                    <dt className="telia-textfield__label">Adresse:</dt>
                    <dd className="">{address}</dd>
                </div>
                {shouldShowAddressInputs && (
                    <Checkbox className="fwa-personal-details-form__checkbox">
                        <Checkbox.Trigger
                            checked={isCustomAddressSelected}
                            onCheckedChange={() => setCustomAddressChecked(!isCustomAddressSelected)}
                        />
                        <span>Jeg vil ha antennen tilsendt hjem i stedet for på hytta</span>
                    </Checkbox>
                )}
                {shouldShowAddressInputs && isCustomAddressSelected && (
                    <>
                        <Input
                            type="text"
                            name={VALIDATION_FIELD.STREET}
                            label={TEXT.PERSONAL_DETAILS.STREET}
                            disabled={false}
                            data-di-mask
                        />
                        <FormRow format={FormRowFormats.FORTY_SIXTY} data-di-mask>
                            <Input
                                type="text"
                                name={VALIDATION_FIELD.POSTCODE}
                                label={TEXT.PERSONAL_DETAILS.POSTCODE}
                                disabled={false}
                            />
                            <Input
                                type="text"
                                name={VALIDATION_FIELD.CITY}
                                label={TEXT.PERSONAL_DETAILS.CITY}
                                disabled={false}
                            />
                        </FormRow>
                    </>
                )}
                <Input
                    type="email"
                    name={VALIDATION_FIELD.PRODUCT_USER_EMAIL}
                    label={TEXT.PERSONAL_DETAILS.EMAIL}
                    disabled={false}
                    data-di-mask
                />
                <Input
                    type="tel"
                    name={VALIDATION_FIELD.PRODUCT_USER_PHONE}
                    label={TEXT.PERSONAL_DETAILS.PHONENUMBER}
                    disabled={false}
                    data-di-mask
                />
            </FieldSet>
        </RapidForm>
    </div>
);

const mapStateToProps = (state: RootState): StateProps => ({
    fwaForm: getFormById(state, "personalDetailsFwaForm"),
    address: getSelectedAddress(state),
    shouldShowAddressInputs: isSelectedPackageCabinDIY(state),
    isCustomAddressSelected: isCustomAddressSelectedSelector(state),
});

export default connect(mapStateToProps)(PersonalDetailsForm);
